var map = {
	"./AIF/fromToArrow.svg": 714,
	"./AIF/rupee-icon.svg": 715,
	"./AIF/switch_class_icon.svg": 716,
	"./AIF/switch_option_icon.svg": 717,
	"./MOTOS.png": 718,
	"./about/aboutBG.jpg": 719,
	"./about/abtres.png": 720,
	"./about/abtres.svg": 721,
	"./about/building.jpg": 722,
	"./about/download.png": 723,
	"./about/download.svg": 724,
	"./about/focusbtn.svg": 725,
	"./about/headingImage.png": 726,
	"./about/investment.png": 727,
	"./about/investment2.png": 728,
	"./about/overview1.png": 729,
	"./about/people.svg": 730,
	"./about/ra-profile.jpg": 731,
	"./about/star.svg": 732,
	"./about/trust.png": 733,
	"./account/accountBG.svg": 734,
	"./account/accountstatement.svg": 735,
	"./account/captcha.svg": 736,
	"./account/greenRight.svg": 737,
	"./arrowleft.png": 738,
	"./calender.svg": 739,
	"./cart/Ellipse 2112.svg": 740,
	"./cart/Group 134.png": 741,
	"./cart/Group 7244.png": 742,
	"./cart/Group 7553.png": 743,
	"./cart/Group 9056.png": 744,
	"./cart/Homepage/Account Statment.png": 745,
	"./cart/Homepage/App Store.png": 746,
	"./cart/Homepage/Blog-1.png": 747,
	"./cart/Homepage/Blog-2.png": 748,
	"./cart/Homepage/Blog-3.png": 749,
	"./cart/Homepage/Blog-4.png": 750,
	"./cart/Homepage/Blogs.png": 751,
	"./cart/Homepage/Business Portfolio.png": 752,
	"./cart/Homepage/Car-Big.png": 753,
	"./cart/Homepage/Car-inner.png": 754,
	"./cart/Homepage/Downloads.png": 755,
	"./cart/Homepage/Education-Big.png": 756,
	"./cart/Homepage/Education-inner.png": 757,
	"./cart/Homepage/Equity-man.png": 758,
	"./cart/Homepage/Facebook.png": 759,
	"./cart/Homepage/Footer Arrow.png": 760,
	"./cart/Homepage/Group Sites.png": 761,
	"./cart/Homepage/Holiday-Big.png": 762,
	"./cart/Homepage/Holiday-inner.png": 763,
	"./cart/Homepage/House-Big.png": 764,
	"./cart/Homepage/House-Inner.png": 765,
	"./cart/Homepage/Investment-Background.png": 766,
	"./cart/Homepage/Logo.png": 767,
	"./cart/Homepage/Main-blog.png": 768,
	"./cart/Homepage/Map.png": 769,
	"./cart/Homepage/Money Plant.png": 770,
	"./cart/Homepage/Motilal Building.svg": 771,
	"./cart/Homepage/Multiple-girl.png": 772,
	"./cart/Homepage/NAV.png": 773,
	"./cart/Homepage/Newsletter Logo.png": 774,
	"./cart/Homepage/Next-trillion.png": 775,
	"./cart/Homepage/PiggyBank.png": 776,
	"./cart/Homepage/Play man.png": 777,
	"./cart/Homepage/Playstore Logo.png": 778,
	"./cart/Homepage/Plus-Icon.png": 779,
	"./cart/Homepage/Rectangle 4132.png": 780,
	"./cart/Homepage/Rectangle 4293.png": 781,
	"./cart/Homepage/TAX.png": 782,
	"./cart/Homepage/Tools.png": 783,
	"./cart/Homepage/Top Arrow.png": 784,
	"./cart/Homepage/Top Button Arrow.png": 785,
	"./cart/Homepage/Twitter.png": 786,
	"./cart/Homepage/Value Strategy.png": 787,
	"./cart/Homepage/Wedding-Big.png": 788,
	"./cart/Homepage/Wedding-inner.png": 789,
	"./cart/Homepage/Whatsapp Logo.png": 790,
	"./cart/Homepage/Youtube.png": 791,
	"./cart/Homepage/adult-banking-blur-1.png": 792,
	"./cart/Homepage/apple.png": 793,
	"./cart/Homepage/building.png": 794,
	"./cart/Homepage/cancel.png": 795,
	"./cart/Homepage/cart.png": 796,
	"./cart/Homepage/common-application-icon.svg": 797,
	"./cart/Homepage/compare-icon.svg": 798,
	"./cart/Homepage/compare-portfolio-default 1.png": 799,
	"./cart/Homepage/compare-portfolio-default.png": 800,
	"./cart/Homepage/compare-portfolio.png": 801,
	"./cart/Homepage/compounding-magic-default.png": 802,
	"./cart/Homepage/compounding-magic.png": 803,
	"./cart/Homepage/factsheet-icon.svg": 804,
	"./cart/Homepage/fundcard-bg.svg": 805,
	"./cart/Homepage/fundsize-icon.svg": 806,
	"./cart/Homepage/goal-calculator-default.png": 807,
	"./cart/Homepage/goal-calculator.png": 808,
	"./cart/Homepage/info-icon.svg": 809,
	"./cart/Homepage/investor logo.png": 810,
	"./cart/Homepage/key-man.svg": 811,
	"./cart/Homepage/leaflte-icon.svg": 812,
	"./cart/Homepage/mail.png": 813,
	"./cart/Homepage/minamt-icon.svg": 814,
	"./cart/Homepage/piggyBG.svg": 815,
	"./cart/Homepage/playstore.png": 816,
	"./cart/Homepage/presentation-icon.svg": 817,
	"./cart/Homepage/return-icon.svg": 818,
	"./cart/Homepage/right-arrow.png": 819,
	"./cart/Homepage/risk-icon.svg": 820,
	"./cart/Homepage/risk-veryhigh.png": 821,
	"./cart/Homepage/search.png": 822,
	"./cart/Homepage/share-icon.png": 823,
	"./cart/Homepage/sip-calculator-default.png": 824,
	"./cart/Homepage/sip-calculator.png": 825,
	"./cart/Homepage/smartphone.png": 826,
	"./cart/Homepage/taxBG.svg": 827,
	"./cart/Homepage/undraw_super_woman_dv0y.png": 828,
	"./cart/Homepage/user.png": 829,
	"./cart/Homepage/whatsapp.png": 830,
	"./cart/Money Flag.png": 831,
	"./cart/Rectangle 3362.png": 832,
	"./cart/Shake Hand.png": 833,
	"./cart/addAcc.svg": 834,
	"./cart/arrowleft.png": 835,
	"./cart/bob.png": 836,
	"./cart/c1.png": 837,
	"./cart/calendar_icon.svg": 838,
	"./cart/card-sip-icon.svg": 839,
	"./cart/card_lumpsum_icon.svg": 840,
	"./cart/cart_dnf.svg": 841,
	"./cart/close_icon.svg": 842,
	"./cart/e1.svg": 843,
	"./cart/e2.svg": 844,
	"./cart/e3.svg": 845,
	"./cart/e4.svg": 846,
	"./cart/f1.png": 847,
	"./cart/faq.svg": 848,
	"./cart/female-icon.png": 849,
	"./cart/fofBG.svg": 850,
	"./cart/fofIcon.svg": 851,
	"./cart/greenRight.svg": 852,
	"./cart/holding_icon.svg": 853,
	"./cart/hourse.svg": 854,
	"./cart/investment/Group 8534.jpg": 855,
	"./cart/investment/Group 8534@2x.jpg": 856,
	"./cart/investment/calender.svg": 857,
	"./cart/investment/female.svg": 858,
	"./cart/investment/leftBG.svg": 859,
	"./cart/investment/leftbg.jpg": 860,
	"./cart/investment/lumsum.svg": 861,
	"./cart/investment/male.svg": 862,
	"./cart/investment/red.svg": 863,
	"./cart/investment/rightbg.svg": 864,
	"./cart/investment/sip.svg": 865,
	"./cart/investment/switch.svg": 866,
	"./cart/investment/upload.svg": 867,
	"./cart/key1.jpg": 868,
	"./cart/key2.jpg": 869,
	"./cart/key3.jpg": 870,
	"./cart/keyimg.jpg": 871,
	"./cart/lock.svg": 872,
	"./cart/loginpeople.svg": 873,
	"./cart/m1.png": 874,
	"./cart/m2.png": 875,
	"./cart/male-icon.png": 876,
	"./cart/media.jpg": 877,
	"./cart/mens.png": 878,
	"./cart/mens.svg": 879,
	"./cart/mfDetailbg.svg": 880,
	"./cart/mftimeline.svg": 881,
	"./cart/mgBG.svg": 882,
	"./cart/minus_icon.svg": 883,
	"./cart/noun_locked lock_1010538.svg": 884,
	"./cart/overview1.png": 885,
	"./cart/p1.png": 886,
	"./cart/playicon.svg": 887,
	"./cart/plus_icon.svg": 888,
	"./cart/popup_side_img.svg": 889,
	"./cart/postlogin/authentication-icon.svg": 890,
	"./cart/postlogin/bank-icon.svg": 891,
	"./cart/postlogin/bitcoin.svg": 892,
	"./cart/postlogin/boost-btn-icon.png": 893,
	"./cart/postlogin/broker-error-icon.svg": 894,
	"./cart/postlogin/broker-icon.svg": 895,
	"./cart/postlogin/broker-success-icon.svg": 896,
	"./cart/postlogin/call-icon.svg": 897,
	"./cart/postlogin/cancel (2).svg": 898,
	"./cart/postlogin/card-add-to-cart-icon.svg": 899,
	"./cart/postlogin/card-lumpsum-icon.svg": 900,
	"./cart/postlogin/card-sip-icon.svg": 901,
	"./cart/postlogin/cart-icon.svg": 902,
	"./cart/postlogin/carttable-infoicon.svg": 903,
	"./cart/postlogin/cashflow-checkout-icon.svg": 904,
	"./cart/postlogin/cheque-icon.svg": 905,
	"./cart/postlogin/delete-icon.svg": 906,
	"./cart/postlogin/direct-ribbon.svg": 907,
	"./cart/postlogin/edit-icon.svg": 908,
	"./cart/postlogin/elss-fund.gif": 909,
	"./cart/postlogin/email-icon.svg": 910,
	"./cart/postlogin/error-table-icon.svg": 911,
	"./cart/postlogin/exit-load-icon.svg": 912,
	"./cart/postlogin/facebook-logo.svg": 913,
	"./cart/postlogin/filter-icon.svg": 914,
	"./cart/postlogin/folio-icon.svg": 915,
	"./cart/postlogin/folio-joint.svg": 916,
	"./cart/postlogin/folio-minor.svg": 917,
	"./cart/postlogin/folio-single.svg": 918,
	"./cart/postlogin/footer-blue-bg.svg": 919,
	"./cart/postlogin/footer-chatwithus-icon.svg": 920,
	"./cart/postlogin/footer-faqs-icon.svg": 921,
	"./cart/postlogin/footer-searchlocation-icon.svg": 922,
	"./cart/postlogin/footer-whatsapp-icon.svg": 923,
	"./cart/postlogin/greenarrow-icon.svg": 924,
	"./cart/postlogin/greentick-icon.svg": 925,
	"./cart/postlogin/grid-icon.svg": 926,
	"./cart/postlogin/index-funds.gif": 927,
	"./cart/postlogin/info-icon.svg": 928,
	"./cart/postlogin/infobig-icon.svg": 929,
	"./cart/postlogin/instagram-logo.svg": 930,
	"./cart/postlogin/internationalBG.jpg": 931,
	"./cart/postlogin/list-icon.svg": 932,
	"./cart/postlogin/loader-logo.svg": 933,
	"./cart/postlogin/main-clip.svg": 934,
	"./cart/postlogin/mandate-homepage-banner.jpg": 935,
	"./cart/postlogin/mandate-icon.svg": 936,
	"./cart/postlogin/mastercard-icon.svg": 937,
	"./cart/postlogin/money-bag.svg": 938,
	"./cart/postlogin/more-vertical.svg": 939,
	"./cart/postlogin/multiasset-balancing-mob-banner.jpg": 940,
	"./cart/postlogin/neft-rtgs-icon.svg": 941,
	"./cart/postlogin/neftrtgs-icon.svg": 942,
	"./cart/postlogin/net-banking-icon.svg": 943,
	"./cart/postlogin/netbanking-otm-icon.svg": 944,
	"./cart/postlogin/order-icon.svg": 945,
	"./cart/postlogin/otm-mandate-mob.jpg": 946,
	"./cart/postlogin/payment-fail.svg": 947,
	"./cart/postlogin/payment-method-icon.svg": 948,
	"./cart/postlogin/payment-success.svg": 949,
	"./cart/postlogin/payment-summary-icon.svg": 950,
	"./cart/postlogin/payment-waiting.svg": 951,
	"./cart/postlogin/pms-homepage-mob-banner.jpg": 952,
	"./cart/postlogin/profit.svg": 953,
	"./cart/postlogin/redamount-icon.svg": 954,
	"./cart/postlogin/redarrow-icon.svg": 955,
	"./cart/postlogin/redemption-icon.svg": 956,
	"./cart/postlogin/regular-ribbon.svg": 957,
	"./cart/postlogin/review-checkout-icon.svg": 958,
	"./cart/postlogin/rupee-sign.svg": 959,
	"./cart/postlogin/schedule-sip-icon.svg": 960,
	"./cart/postlogin/search-icon.svg": 961,
	"./cart/postlogin/sip-error-icon.svg": 962,
	"./cart/postlogin/sip-shubh-aarambh-mob-banner.jpg": 963,
	"./cart/postlogin/sipmenu-bank.svg": 964,
	"./cart/postlogin/sipmenu-cancel.svg": 965,
	"./cart/postlogin/sipmenu-feedback.svg": 966,
	"./cart/postlogin/sipmenu-pause.svg": 967,
	"./cart/postlogin/sipmenu-statement.svg": 968,
	"./cart/postlogin/small-clip.svg": 969,
	"./cart/postlogin/stp-icon.svg": 970,
	"./cart/postlogin/swp-icon.svg": 971,
	"./cart/postlogin/tax-icon.svg": 972,
	"./cart/postlogin/thank-you.png": 973,
	"./cart/postlogin/twitter-logo.svg": 974,
	"./cart/postlogin/upi-icon.svg": 975,
	"./cart/postlogin/whatsapp-banner.jpg": 976,
	"./cart/postlogin/x-circle.svg": 977,
	"./cart/postlogin/youtube-logo.svg": 978,
	"./cart/rightCheck.svg": 979,
	"./cart/rightarrow.svg": 980,
	"./cart/rupeesBg.svg": 981,
	"./cart/rupeesIcon.svg": 982,
	"./cart/sbi.png": 983,
	"./cart/searchbar.svg": 984,
	"./cart/sip_info_icon.svg": 985,
	"./cart/tagmsg.svg": 986,
	"./cart/taxBG.svg": 987,
	"./cart/taxIcon.svg": 988,
	"./cart/transgender-icon.png": 989,
	"./cart/v1.svg": 990,
	"./cart/v2.svg": 991,
	"./cart/v3.svg": 992,
	"./cart/v4.svg": 993,
	"./cart/v5.svg": 994,
	"./cart/v6.svg": 995,
	"./cart/v7.svg": 996,
	"./cart/yellowcolor.png": 997,
	"./cart/yellowcolor2x.png": 998,
	"./category/addedcart-icon.svg": 999,
	"./category/addtocart-icon.svg": 1000,
	"./category/calendar_icon.svg": 1001,
	"./category/card-lumpsum-icon.svg": 1002,
	"./category/card-sip-icon.svg": 1003,
	"./category/curved-arrow-right.svg": 1004,
	"./category/curved-arrow.svg": 1005,
	"./category/fundcard-bg.svg": 1006,
	"./category/fundsize-icon.svg": 1007,
	"./category/grid-icon.svg": 1008,
	"./category/info-icon.svg": 1009,
	"./category/list-icon.svg": 1010,
	"./category/minamt-icon.svg": 1011,
	"./category/qb_cancel_icon.svg": 1012,
	"./category/qb_mod_icon.svg": 1013,
	"./category/qb_remove_item.svg": 1014,
	"./category/return-icon.svg": 1015,
	"./category/risk-icon.svg": 1016,
	"./category/risk-veryhigh.png": 1017,
	"./category/search-icon.svg": 1018,
	"./category/shopping-bag.svg": 1019,
	"./chart1.svg": 1020,
	"./close.png": 452,
	"./contact/Map.png": 1021,
	"./contact/building.svg": 1022,
	"./contact/building_icon.png": 1023,
	"./contact/mail.png": 1024,
	"./contact/smartphone.png": 1025,
	"./contact/user.png": 1026,
	"./dash/404_error.svg": 1027,
	"./dash/accountstmt.svg": 1028,
	"./dash/annualreturn.png": 1029,
	"./dash/banner.svg": 1030,
	"./dash/bar.svg": 1031,
	"./dash/buymore.svg": 1032,
	"./dash/calVec.svg": 1033,
	"./dash/coin-light.svg": 1034,
	"./dash/coin.svg": 1035,
	"./dash/currentvalue.png": 1036,
	"./dash/dailygain.png": 1037,
	"./dash/dash.svg": 1038,
	"./dash/green.svg": 1039,
	"./dash/investment.png": 1040,
	"./dash/latestActive.svg": 1041,
	"./dash/minus.svg": 1042,
	"./dash/orderbook.svg": 1043,
	"./dash/plus.svg": 1044,
	"./dash/portfolio-dnf-icon.svg": 1045,
	"./dash/portfolioview.png": 1046,
	"./dash/red.svg": 1047,
	"./dash/redem.svg": 1048,
	"./dash/scheduletrans.svg": 1049,
	"./dash/sipUp.svg": 1050,
	"./dash/totalInvestment.png": 1051,
	"./dash/totalgain.png": 1052,
	"./dash/transhis.svg": 1053,
	"./dash/upcomming.svg": 1054,
	"./dash/zbp_folio_creation_icon.svg": 1055,
	"./dash/zbp_make_payment_icon.svg": 1056,
	"./dash/zbp_select_fund_icon.svg": 1057,
	"./dash/zero_balance_portfolio.svg": 1058,
	"./dash/zero_balance_steps_icon.svg": 1059,
	"./download/Edit.svg": 1060,
	"./download/banner.svg": 1061,
	"./download/close.svg": 1062,
	"./download/cloud.svg": 1063,
	"./download/email.svg": 1064,
	"./download/pdf.png": 1065,
	"./download/view.svg": 1066,
	"./download/whatsapp.svg": 1067,
	"./download/xls.png": 1068,
	"./e-mandate-success-icon.png": 453,
	"./faq/faq.svg": 1069,
	"./faq/searchbar.svg": 1070,
	"./fundIcon/MHR.svg": 1071,
	"./fundIcon/fofBG.svg": 1072,
	"./fundIcon/fofIcon.svg": 1073,
	"./fundIcon/growth_icon.svg": 1074,
	"./fundIcon/growth_icon1.svg": 1075,
	"./fundIcon/growth_icon3.svg": 1076,
	"./fundIcon/rupeesBg.svg": 1077,
	"./fundIcon/rupeesIcon.svg": 1078,
	"./fundIcon/taxBG.svg": 1079,
	"./fundIcon/taxIcon.svg": 1080,
	"./greenRight.svg": 1081,
	"./home/Blog-1.png": 1082,
	"./home/Blog-2.png": 1083,
	"./home/Blog-3.png": 1084,
	"./home/Blog-4.png": 1085,
	"./home/Equity-man.png": 1086,
	"./home/Investment-Background.png": 1087,
	"./home/Main-blog.png": 1088,
	"./home/Multiple-girl.png": 1089,
	"./home/Playman.png": 1090,
	"./home/account_statement.png": 1091,
	"./home/apple.png": 1092,
	"./home/banner1.svg": 1093,
	"./home/blog.png": 1094,
	"./home/download.png": 1095,
	"./home/investorlogo.png": 1096,
	"./home/key-man.svg": 1097,
	"./home/nav.png": 1098,
	"./home/playstore.png": 1099,
	"./home/ques.png": 1100,
	"./home/smartmockups_jzwdpybx.png": 1101,
	"./home/tools.png": 1102,
	"./home/whatsapp.png": 1103,
	"./info.png": 1104,
	"./international/internationalBG.jpg": 1105,
	"./international/key1.png": 1106,
	"./international/key2.png": 1107,
	"./international/key3.png": 1108,
	"./international/mens.jpg": 1109,
	"./international/tag.png": 1110,
	"./intersetialBigImg.svg": 1111,
	"./investment/Group 8534.jpg": 1112,
	"./investment/Group 8534@2x.jpg": 1113,
	"./investment/boost-btn-icon.png": 1114,
	"./investment/calender.svg": 1115,
	"./investment/female.svg": 1116,
	"./investment/filter-icon.svg": 1117,
	"./investment/leftBG.svg": 1118,
	"./investment/leftbg.jpg": 1119,
	"./investment/lumsum.svg": 1120,
	"./investment/male.svg": 1121,
	"./investment/order-icon.svg": 1122,
	"./investment/red.svg": 1123,
	"./investment/rightbg.svg": 1124,
	"./investment/schedule-sip-icon.svg": 1125,
	"./investment/sip-boosted.png": 1126,
	"./investment/sip.svg": 1127,
	"./investment/sipmenu-bank.svg": 1128,
	"./investment/sipmenu-cancel.svg": 1129,
	"./investment/sipmenu-feedback.svg": 1130,
	"./investment/sipmenu-pause.svg": 1131,
	"./investment/sipmenu-statement.svg": 1132,
	"./investment/small-clip.svg": 1133,
	"./investment/switch.svg": 1134,
	"./investment/upload.svg": 1135,
	"./investment/x-circle.svg": 1136,
	"./isip.svg": 1137,
	"./kyc/thank-you.png": 1138,
	"./landing/MHR.svg": 1139,
	"./landing/PMS-BG.svg": 1140,
	"./landing/diverse-portfolio-w.png": 1141,
	"./landing/fofBG.svg": 1142,
	"./landing/fofIcon.svg": 1143,
	"./landing/growth_icon.svg": 1144,
	"./landing/growth_icon1.svg": 1145,
	"./landing/growth_icon3.svg": 1146,
	"./landing/hourse.svg": 1147,
	"./landing/key1.jpg": 1148,
	"./landing/key2.jpg": 1149,
	"./landing/key3.jpg": 1150,
	"./landing/keyimg.jpg": 1151,
	"./landing/m1.png": 1152,
	"./landing/m2.png": 1153,
	"./landing/m3.png": 1154,
	"./landing/m4.png": 1155,
	"./landing/m5.png": 1156,
	"./landing/mgBG.svg": 1157,
	"./landing/p1.png": 1158,
	"./landing/p2.png": 1159,
	"./landing/p3.png": 1160,
	"./landing/p4.png": 1161,
	"./landing/p5.png": 1162,
	"./landing/passBGbottom.svg": 1163,
	"./landing/playicon.svg": 1164,
	"./landing/pms1.png": 1165,
	"./landing/pms2.png": 1166,
	"./landing/pms3.png": 1167,
	"./landing/pms4.png": 1168,
	"./landing/professional-management-w.png": 1169,
	"./landing/rightarrow.svg": 1170,
	"./landing/rupeesBg.svg": 1171,
	"./landing/rupeesIcon.svg": 1172,
	"./landing/safe-transperent-w.png": 1173,
	"./landing/tax-saving-w.png": 1174,
	"./landing/taxBG.svg": 1175,
	"./landing/taxIcon.svg": 1176,
	"./leftBG.svg": 1177,
	"./leftbg.jpg": 1178,
	"./listing/Mask Group 31.svg": 1179,
	"./listing/P_M_R.svg": 1180,
	"./listing/Rectangle 4184.svg": 1181,
	"./listing/bg_pms.svg": 1182,
	"./listing/charttest.svg": 1183,
	"./listing/d.png": 1184,
	"./listing/db_small.png": 1185,
	"./listing/e1.svg": 1186,
	"./listing/e2.svg": 1187,
	"./listing/e3.svg": 1188,
	"./listing/e4.svg": 1189,
	"./listing/investmentp.svg": 1190,
	"./listing/l1.png": 1191,
	"./listing/lt.png": 1192,
	"./listing/mens.png": 1193,
	"./listing/mens.svg": 1194,
	"./listing/mfDetailbg.svg": 1195,
	"./listing/p1.png": 1196,
	"./listing/p2.png": 1197,
	"./listing/p_icon1.svg": 1198,
	"./listing/pms-startegy-banner.png": 1199,
	"./listing/pmsBG.svg": 1200,
	"./listing/pms_v1.png": 1201,
	"./listing/pms_v10.png": 1202,
	"./listing/pms_v2.png": 1203,
	"./listing/pms_v3.png": 1204,
	"./listing/pms_v4.png": 1205,
	"./listing/pms_v5.png": 1206,
	"./listing/pms_v6.png": 1207,
	"./listing/pms_v7.png": 1208,
	"./listing/pms_v8.png": 1209,
	"./listing/pms_v9.png": 1210,
	"./listing/pmsbottom.svg": 1211,
	"./listing/po.png": 1212,
	"./listing/portolifo_left.svg": 1213,
	"./listing/portolifo_right.svg": 1214,
	"./listing/r1.png": 1215,
	"./listing/r_small.png": 1216,
	"./listing/red_pdf.svg": 1217,
	"./listing/tr.png": 1218,
	"./listing/v1.svg": 1219,
	"./listing/v10.svg": 1220,
	"./listing/v11.svg": 1221,
	"./listing/v12.svg": 1222,
	"./listing/v13.svg": 1223,
	"./listing/v14.svg": 1224,
	"./listing/v2.svg": 1225,
	"./listing/v3.svg": 1226,
	"./listing/v4.svg": 1227,
	"./listing/v5.svg": 1228,
	"./listing/v6.svg": 1229,
	"./listing/v7.svg": 1230,
	"./listing/v9.svg": 1231,
	"./listing/why1.png": 1232,
	"./listing/why2.png": 1233,
	"./listing/why3.png": 1234,
	"./listing/why4.png": 1235,
	"./lock.svg": 1236,
	"./lockpwd.png": 1237,
	"./login-image.png": 1238,
	"./login/cancel_icon.png": 1239,
	"./login/check_icon.png": 1240,
	"./login/checked.png": 454,
	"./login/city_icon.png": 1241,
	"./login/email_icon.png": 1242,
	"./login/gold_passcode.jpg": 1243,
	"./login/grow_more.png": 1244,
	"./login/grow_more_label_line.png": 1245,
	"./login/kyc_verify_icon.png": 1246,
	"./login/mobile_icon.png": 1247,
	"./login/pan_icon.png": 1248,
	"./login/pan_name_icon.png": 1249,
	"./login/password_icon.png": 1250,
	"./login/show_password_icon.png": 1251,
	"./loginpeople.svg": 1252,
	"./logo-dit.png": 1253,
	"./logo-mo-amc.png": 448,
	"./logo-mo-amc2.png": 449,
	"./logo.svg": 1254,
	"./manageBank/icon-mandate.svg": 1255,
	"./manageBank/icon_bank.svg": 1256,
	"./manageBank/notestyle.png": 1257,
	"./manageBank/success.svg": 1258,
	"./minus.png": 1259,
	"./nav/Group 253.svg": 1260,
	"./nav/aldemat_navicon-light.svg": 1261,
	"./nav/aldemat_navicon.svg": 1262,
	"./nav/goalbase_navicon-light.svg": 1263,
	"./nav/goalbase_navicon.svg": 1264,
	"./nav/invest_navicon-light.svg": 1265,
	"./nav/invest_navicon.svg": 1266,
	"./nav/manageac_navicon-light.svg": 1267,
	"./nav/manageac_navicon.svg": 1268,
	"./nav/managepr_navicon-light.svg": 1269,
	"./nav/managepr_navicon.svg": 1270,
	"./nav/mf-amc-brst-logo.png": 1271,
	"./nav/mf-m-min-logo.svg": 1272,
	"./nav/mnschedule_navicon-light.svg": 1273,
	"./nav/mnschedule_navicon.svg": 1274,
	"./nav/myportfolio_navicon-light.svg": 1275,
	"./nav/myportfolio_navicon.svg": 1276,
	"./nav/navBanner.svg": 1277,
	"./nav/orderbook_navicon-light.svg": 1278,
	"./nav/orderbook_navicon.svg": 1279,
	"./nav/profile-icon.png": 1280,
	"./nav/redemption_navicon-light.svg": 1281,
	"./nav/redemption_navicon.svg": 1282,
	"./nav/report_navicon-light.svg": 1283,
	"./nav/report_navicon.svg": 1284,
	"./nav/smartplan_navicon-light.svg": 1285,
	"./nav/smartplan_navicon.svg": 1286,
	"./nav/transfer_navicon-light.svg": 1287,
	"./nav/transfer_navicon.svg": 1288,
	"./onboarding/female-icon.png": 1289,
	"./onboarding/male-icon.png": 1290,
	"./onboarding/transgender-icon.png": 1291,
	"./option_icon.png": 1292,
	"./payment/info-icon.svg": 1293,
	"./payment/mastercard-icon.svg": 1294,
	"./payment/neft-rtgs-icon.svg": 1295,
	"./payment/net-banking-icon.svg": 1296,
	"./payment/payment-method-icon.svg": 1297,
	"./payment/upi-icon.svg": 1298,
	"./percent-icon.png": 1299,
	"./plusicon.png": 1300,
	"./pms/BusinessPortfolio.png": 1301,
	"./pms/DedicatedRMs.png": 1302,
	"./pms/EqualityPortfolioGirl.svg": 1303,
	"./pms/IndiaOpportunityV1.png": 1304,
	"./pms/IndiaOpportunityV2.png": 1305,
	"./pms/Linkedinlogo.png": 1306,
	"./pms/Next-trillion.png": 1307,
	"./pms/PMS-Tree.svg": 1308,
	"./pms/PerformanceChart.png": 1309,
	"./pms/RaamdeoAggarwal.png": 1310,
	"./pms/RequestDeskGirl.svg": 1311,
	"./pms/RightWave.png": 1312,
	"./pms/Segregatedportfolios.png": 1313,
	"./pms/Telephone.png": 1314,
	"./pms/Transparency.png": 1315,
	"./pms/ValueStrategy.png": 1316,
	"./prelogin-header/Logo.png": 1317,
	"./prelogin-header/basket-banner.gif": 1318,
	"./prelogin-header/cashflow-img.svg": 1319,
	"./prelogin-header/login-lock.svg": 1320,
	"./prelogin-header/movi-img.svg": 1321,
	"./prelogin-header/quick-invest-icon.svg": 1322,
	"./profile/ach_icon.png": 1323,
	"./profile/addprofile.svg": 1324,
	"./profile/bill_icon.png": 1325,
	"./profile/contact_icon.png": 1326,
	"./profile/fatca2_icon.png": 1327,
	"./profile/folio-icon.svg": 1328,
	"./profile/mandate_icon.png": 1329,
	"./profile/minus.png": 1330,
	"./profile/netbankg_icon.png": 1331,
	"./profile/nominee_icon.png": 1332,
	"./profile/plus.png": 1333,
	"./profile/profile_pic.png": 1334,
	"./profile/user_icon.png": 1335,
	"./reedem.svg": 1336,
	"./rightarrow.svg": 1337,
	"./rightbg.svg": 1338,
	"./searchicon.png": 1339,
	"./share-icon.png": 1340,
	"./sip.svg": 1341,
	"./stp.svg": 1342,
	"./switch.svg": 1343,
	"./swp.svg": 1344,
	"./tnc/Plus.png": 1345,
	"./tnc/disclaimer.jpg": 1346,
	"./tnc/minus.png": 1347,
	"./tnc/terms.jpg": 1348,
	"./tnc/yellowcolor.png": 1349,
	"./tools/Car-Big.png": 1350,
	"./tools/Car-inner.png": 1351,
	"./tools/Education-Big.png": 1352,
	"./tools/Education-inner.png": 1353,
	"./tools/Holiday-Big.png": 1354,
	"./tools/Holiday-inner.png": 1355,
	"./tools/House-Big.png": 1356,
	"./tools/House-Inner.png": 1357,
	"./tools/Money Plant.png": 1358,
	"./tools/Wedding-Big.png": 1359,
	"./tools/Wedding-inner.png": 1360,
	"./tools/compare-portfolio-default.png": 1361,
	"./tools/compare-portfolio.png": 1362,
	"./tools/compounding-magic-default.png": 1363,
	"./tools/compounding-magic.png": 1364,
	"./tools/goal-calculator-default.png": 1365,
	"./tools/goal-calculator.png": 1366,
	"./tools/sip-calculator-default.png": 1367,
	"./tools/sip-calculator.png": 1368,
	"./trackorder/calender.svg": 1369,
	"./trackorder/filter-icon.svg": 1370,
	"./trackorder/order-icon.svg": 1371,
	"./trackorder/order_book_dfn.svg": 1372,
	"./trackorder/small-clip.svg": 1373,
	"./trans/Group 8999.png": 1374,
	"./trans/Group 9000.png": 1375,
	"./trans/Rectangle 4355.png": 1376,
	"./trans/Rectangle 4356.png": 1377,
	"./trans/Vector Smart Object.svg": 1378,
	"./trans/addmoney.png": 1379,
	"./trans/authentication-icon.svg": 1380,
	"./trans/bank-icon.svg": 1381,
	"./trans/boost-icon.png": 1382,
	"./trans/broker-icon.svg": 1383,
	"./trans/cart-icon.svg": 1384,
	"./trans/cashflow_icon.svg": 1385,
	"./trans/exit-load-icon.svg": 1386,
	"./trans/folio-icon.svg": 1387,
	"./trans/greenarrow-icon.svg": 1388,
	"./trans/info-icon.svg": 1389,
	"./trans/infobig-icon.svg": 1390,
	"./trans/invest-fund-icon.svg": 1391,
	"./trans/isip-icon.svg": 1392,
	"./trans/isip.png": 1393,
	"./trans/main-clip.svg": 455,
	"./trans/minus-icon.svg": 1394,
	"./trans/new-fund-icon.svg": 1395,
	"./trans/new-fund-side-img.svg": 1396,
	"./trans/pigybank.png": 1397,
	"./trans/plus-icon.svg": 1398,
	"./trans/redamount-icon.svg": 1399,
	"./trans/redemption-icon.svg": 1400,
	"./trans/redemtionthank.png": 1401,
	"./trans/small-clip.svg": 1402,
	"./trans/stp-icon.svg": 1403,
	"./trans/swp-icon.svg": 1404,
	"./trans/swp-img.svg": 1405,
	"./trans/tax-icon.svg": 1406,
	"./transResponse/elss-fund.gif": 1407,
	"./transResponse/index-funds.gif": 1408,
	"./transResponse/mandate-homepage-banner.jpg": 1409,
	"./transResponse/order-icon.svg": 1410,
	"./transResponse/otm-mandate-mob.jpg": 1411,
	"./transResponse/payment-success.svg": 1412,
	"./transResponse/whatsapp-banner.jpg": 1413,
	"./transactionStatus/fail_icon.svg": 1414,
	"./transactionStatus/success_icon.svg": 1415,
	"./transactionStatus/success_icon_old.svg": 1416,
	"./tri.png": 1417,
	"./user.png": 1418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 713;